import script from "./FormulasItems.vue?vue&type=script&setup=true&lang=js"
export * from "./FormulasItems.vue?vue&type=script&setup=true&lang=js"

import "./FormulasItems.vue?vue&type=style&index=0&id=12e4196c&lang=scss"

const __exports__ = script;

export default __exports__